import * as React from 'react';
import MobileAppLogin from './MobileAppLogin';
import { IconButton, Stack } from '@mui/material';
import { Outlet, useLocation, useMatch, useNavigate } from 'react-router';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';
import { enqueueSnackbar, SnackbarProvider } from 'notistack';
import { useEffect } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import MobileAppMenu from './MobileAppMenu';
import { MeEmployeeResponse } from '../../../ApiOld/Api/ApiServerVov';
import LoadingIndicator from '../Shared/LoadingIndicator';
import { useTranslation } from 'react-i18next';
import RequestNotificationModal from '../Shared/RequestNotificationModal';

export interface IMobileAppLayoutProps {
}

export default function MobileAppLayout(props: IMobileAppLayoutProps) {
    const { employeeInfo, loggedIn, companySubdomain, moduleName, setModuleName, setModuleButton, menuHidden, logout, unreadMessages, moduleButton, moduleSecondButton, title, diagnosticAlerts } = useEmployeeContext();
    const navigate = useNavigate();
    const isMatch = useMatch("/:lang/:domain/employee");
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const [notificationOpen, setNotificationOpen] = React.useState(false);
    const [notificationTitle, setNotificationTitle] = React.useState('');
    const [notificationBody, setNotificationBody] = React.useState('');
    const [notificationRequestId, setNotificationRequestId] = React.useState<number | undefined>(undefined);

    window.sendError = (error: string) => {
        if (diagnosticAlerts)
            enqueueSnackbar(error, { variant: 'error' });
    };

    window.handleRequestNotification = (title: string, body: string, requestId: number) => {
        if (diagnosticAlerts)
            enqueueSnackbar(title + ': ' + body + " " + requestId, { variant: 'info' });
        setNotificationTitle(title);
        setNotificationBody(body);
        setNotificationRequestId(requestId);
        setNotificationOpen(true);
    };

    useEffect(() => {
        //@ts-ignore
        if (window.ReactNativeWebView) {
            //@ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'set-language',
                data: JSON.stringify({ lang: i18n.language }),
            }));
        }
    }, [i18n.language]);

    useEffect(() => {
        const metaTag = document.createElement('meta');
        metaTag.name = 'viewport';
        metaTag.content = 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no';
        document.head.appendChild(metaTag);

        // Cleanup in case component unmounts
        return () => {
            document.head.removeChild(metaTag);
        };
    }, []);

    useEffect(() => {
        const path = location.pathname.toLowerCase();

        if (path.includes('menu')) {
            setModuleName('');
        } else if (path.endsWith('activities')) {
            setModuleName('Activities');
        } else if (path.includes('main-activity/1')) {
            setModuleName('ChooseProject');
        } else if (path.includes('range-activity/5')) {
            setModuleName('Doctor');
        } else if (path.includes('range-activity/6')) {
            setModuleName('Holiday');
        } else if (path.includes('range-activity/7')) {
            setModuleName('Illness');
        } else if (path.includes('attendance')) {
            setModuleName('Attendance');
        } else if (path.includes('documents')) {
            setModuleName('Documents');
        } else if (path.includes('wealth')) {
            setModuleName('Property');
        } else if (path.includes('requests')) {
            setModuleName('Tasks');
        } else if (path.includes('request-detail')) {
            setModuleName(title);
        } else if (path.includes('photos')) {
            setModuleName('Photos');
        }


        if (path.includes('range-activity') || path.includes('main-activity')) {
            setModuleButton && setModuleButton(
                <IconButton onClick={() => {
                    window.history.back();
                    setModuleName('Activities');
                    setModuleButton && setModuleButton(null);
                }}>
                    <ArrowBackIosNewIcon />
                </IconButton>
            );
        }
    }, [location.pathname, setModuleButton, setModuleName, title]);

    React.useEffect(() => {
        console.log("logged in", loggedIn, Outlet);
        if (loggedIn && isMatch) {
            navigate('menu');
        }
    }, [loggedIn, navigate, isMatch]);
    if (loggedIn === null) {
        return <LoadingIndicator />;
    }
    else {
        if (loggedIn) {
            return <SnackbarProvider
                maxSnack={6}
                preventDuplicate
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={3000}
                SnackbarProps={{
                    style: {
                        wordBreak: 'break-word',

                    }
                }
                }
                classes={{
                    containerRoot: 'custom-snackbar-container',
                }}
            >

                <Stack>
                    {!menuHidden &&
                        <MobileAppMenu unreadMessages={unreadMessages} moduleButton={moduleButton} moduleSecondButton={moduleSecondButton}
                            employeeInfo={employeeInfo ?? new MeEmployeeResponse()}
                            logout={logout}
                            label={t(moduleName)} domainString={companySubdomain}
                        />
                    }
                    <RequestNotificationModal open={notificationOpen} onClose={() => {
                        setNotificationTitle('');
                        setNotificationBody('');
                        setNotificationRequestId(undefined);
                        setNotificationOpen(false);
                    }}
                        title={notificationTitle} body={notificationBody} requestId={notificationRequestId} />

                    <Outlet />
                </Stack>
            </SnackbarProvider >
        }
        else {
            return (
                <SnackbarProvider
                    maxSnack={6}
                    preventDuplicate
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    autoHideDuration={3000}
                    SnackbarProps={{ style: { wordBreak: 'break-word' } }}
                    classes={{
                        containerRoot: 'custom-snackbar-container',
                    }}>
                    <MobileAppLogin />
                </SnackbarProvider>
            );
        }
    }

}
